<div class="container order-checkout-container">
  <div class="row">
    <div class="col-12">
      <!-- Header -->
      <div class="order-checkout-header mb-4">
        @if (currentOrder) {
          <div class="order-summary">
            <!-- Event Thumbnail and Info -->
            <div class="order-event-section">
              @if (currentOrder.tickets[0]) {
                <div class="event-thumbnail">
                  <img
                    [src]="loadEventImage(currentOrder.tickets[0].event_thumbnail)"
                    [alt]="currentOrder.tickets[0].event_title"
                    class="event-image"
                    onerror="this.src='assets/images/placeholder-event.jpg'" />
                </div>
                <div class="event-details">
                  <h5 class="event-title">{{ currentOrder.tickets[0].event_title }}</h5>
                  <div class="event-meta">
                    <span class="event-date">
                      <i class="pi pi-calendar"></i>
                      {{ currentOrder.tickets[0].event_start_date | date: "dd/MM/yyyy" }} às
                      {{ currentOrder.tickets[0].event_start_date | date: "shortTime" }}
                    </span>
                    <span class="event-venue">
                      <i class="pi pi-map-marker"></i>
                      {{ currentOrder.tickets[0].event_location.location_name }}
                    </span>
                    <span class="event-address">
                      <i class="pi pi-home"></i>
                      {{ currentOrder.tickets[0].event_location.street }},
                      {{ currentOrder.tickets[0].event_location.number }}<br />
                      {{ currentOrder.tickets[0].event_location.city_name }} -
                      {{ currentOrder.tickets[0].event_location.state }}
                    </span>
                  </div>
                </div>
              }
            </div>

            <!-- Tickets Details -->
            <div class="tickets-section">
              <h6 class="tickets-title">Ingressos</h6>
              @for (ticket of currentOrder.tickets; track ticket.id) {
                <div class="ticket-item">
                  <div class="ticket-info">
                    <span class="ticket-name">{{ ticket.title }}</span>
                    <span class="ticket-user">{{ ticket.user_name }} {{ ticket.user_last_name }}</span>
                    <span class="ticket-cpf">CPF: {{ ticket.user_cpf }}</span>
                  </div>
                  <div class="ticket-price">
                    {{ ticket.price | currency: "BRL" }}
                  </div>
                </div>
              }
            </div>

            <!-- Order Summary -->
            <div class="order-amount-section">
              <div class="amount-breakdown">
                <div class="amount-line">
                  <span>Subtotal:</span>
                  <span>{{ getSubtotal() | currency: "BRL" }}</span>
                </div>
                <div class="amount-line total">
                  <span>Total a pagar:</span>
                  <span class="amount-value">{{ currentOrder.total_amount | currency: "BRL" }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Payment Methods -->
      <section class="payment-method mb-4">
        <p class="h5">Método de Pagamento</p>
        <form [formGroup]="checkoutForm">
          <div class="container-payment-methods">
            <button
              (click)="changePaymentMethod('pix')"
              class="radio-button-outlined"
              [ngClass]="{ 'radio-button-solid': checkoutForm.value.paymentMethod == 'pix' }">
              Pix
            </button>
            <button
              (click)="changePaymentMethod('credit_card')"
              class="radio-button-outlined"
              [ngClass]="{ 'radio-button-solid': checkoutForm.value.paymentMethod == 'credit_card' }">
              Cartão de Crédito
            </button>
          </div>
        </form>
      </section>

      <!-- Spinner sempre visível quando necessário -->
      @if (loading || shouldShowProcessingIndicator()) {
        <div class="container-spinner">
          <p-progressSpinner ariaLabel="loading" />
          @if (shouldShowProcessingIndicator()) {
            <div class="payment-status-message">
              <p class="status-text">{{ getPaymentStatusText() }}</p>
              @if (isWebSocketConnected) {
                <small class="connection-indicator">🔗 Conectado</small>
              } @else {
                <small class="connection-indicator">🔄 Reconectando...</small>
              }
            </div>
          }
        </div>
      }

      <!-- Formulário sempre visível, mas com overlay quando processando -->
      <div class="form-container" [class.processing]="loading || shouldShowProcessingIndicator()">
        @if (checkoutForm.value.paymentMethod === 'credit_card') {
          <section class="credit-card-data">
            @if (showCreditCardForm) {
              <div class="credit-card-checkout">
                <form [formGroup]="cardForm" (ngSubmit)="onCreditCardPay()" novalidate>
                  <p class="h5">Dados do Cartão</p>
                  <!-- Cartões salvos -->
                  @if (savedCards.length > 0 && !useNewCard) {
                    <div class="saved-cards mb-3">
                      <label class="form-label fw-bold">Cartões Salvos</label>
                      <div class="saved-cards-list">
                        @for (card of savedCards; track card) {
                          <div class="saved-card-item">
                            <input
                              type="radio"
                              [value]="card.id"
                              [(ngModel)]="selectedCardId"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="useNewCard = false"
                              class="card-radio" />
                            <div class="card-info">
                              <div class="card-header">
                                <span class="card-brand">{{ getCardBrandIcon(card.brand) }} {{ card.brand }}</span>
                                <span class="card-status" [class.active]="card.status === 'active'">
                                  {{ card.status === "active" ? "Ativo" : card.status }}
                                </span>
                              </div>
                              <div class="card-number">{{ formatCardNumber(card) }}</div>
                              <div class="card-details">
                                <span class="card-holder">{{ card.holder_name }}</span>
                                <span class="card-expiry">Expira em {{ formatExpiryDate(card) }}</span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <button
                        type="button"
                        class="btn btn-link p-0 mt-2"
                        (click)="useNewCard = true; selectedCardId = null">
                        <i class="fas fa-plus me-1"></i>
                        Usar novo cartão
                      </button>
                    </div>
                  }
                  <!-- Formulário de novo cartão -->
                  @if (useNewCard || savedCards.length === 0) {
                    <div>
                      <!-- Botão para voltar aos cartões salvos -->
                      @if (useNewCard && savedCards.length > 0) {
                        <div class="mb-3">
                          <button type="button" class="btn btn-link p-0" (click)="useNewCard = false; selectedCardId = null">
                            <i class="fas fa-arrow-left me-1"></i>
                            Voltar aos cartões salvos
                          </button>
                        </div>
                      }
                      <div class="checkout__row">
                        <label for="holderName">Nome no Cartão</label>
                        <input
                          id="holderName"
                          type="text"
                          formControlName="holder_name"
                          placeholder="Nome completo como no cartão"
                          [class.invalid]="invalidCard('holder_name')" />
                        @if (invalidCard('holder_name')) {
                          <small>Informe o nome.</small>
                        }
                      </div>
                      <div class="checkout__row">
                        <label for="cardNumber">Número do Cartão</label>
                        <input
                          id="cardNumber"
                          type="text"
                          formControlName="card_number"
                          placeholder="0000 0000 0000 0000"
                          mask="0000 0000 0000 0000"
                          [class.invalid]="invalidCard('card_number')" />
                        @if (invalidCard('card_number')) {
                          <small>Número inválido.</small>
                        }
                      </div>
                      <div class="checkout__row row">
                        <div class="col-4">
                          <label for="expiryMonth">Mês</label>
                          <input
                            id="expiryMonth"
                            type="number"
                            formControlName="expiry_month"
                            placeholder="MM"
                            min="1"
                            max="12"
                            [class.invalid]="invalidCard('expiry_month')" />
                        </div>
                        <div class="col-4">
                          <label for="expiryYear">Ano</label>
                          <input
                            id="expiryYear"
                            type="number"
                            formControlName="expiry_year"
                            placeholder="YYYY"
                            [class.invalid]="invalidCard('expiry_year')" />
                        </div>
                        <div class="col-4">
                          <label for="cvv">CVV</label>
                          <input
                            id="cvv"
                            type="text"
                            formControlName="cvv"
                            placeholder="123"
                            maxlength="4"
                            [class.invalid]="invalidCard('cvv')" />
                        </div>
                      </div>
                      @if (installmentOptions.length > 1) {
                        <div class="saved-cards mb-3">
                          <label class="form-label fw-bold">Selecione o parcelamento</label>
                          <div class="saved-cards-list">
                            @for (
                              option of installmentOptions;
                              track option.installments
                            ) {
                              @if (showAllInstallments || $index < 6) {
                                <label class="saved-card-item">
                                  <input
                                    type="radio"
                                    formControlName="installments"
                                    [value]="option.installments"
                                    class="card-radio" />
                                  <div class="card-info">
                                    <div class="card-header">
                                      <span class="card-brand">
                                        {{ option.installments }}x
                                        {{
                                          option.installment_cents / 100
                                            | currency: "BRL"
                                        }}
                                        @if (option.installments === 3) {
                                          <span class="card-status"
                                            >Mais popular</span
                                          >
                                        }
                                      </span>
                                      <span class="text-secondary">
                                        @if (option.interest_free) {
                                          Sem juros
                                        } @else {
                                          {{
                                            option.total_cents / 100
                                              | currency: "BRL"
                                          }}
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </label>
                              }
                            }
                          </div>
                          @if (installmentOptions.length > 6) {
                            <button
                              type="button"
                              class="btn btn-link p-0 mt-2"
                              (click)="
                                showAllInstallments = !showAllInstallments
                              ">
                              {{
                                showAllInstallments
                                  ? "Ver menos opções"
                                  : "Visualizar todas opções"
                              }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Mensagens de status -->
                  @if (cardStatusMsg) {
                    <div
                      class="status-banner"
                      [class.ok]="cardStatusOk"
                      [class.error]="!cardStatusOk"
                      [attr.role]="cardStatusOk ? 'status' : 'alert'"
                      [attr.aria-live]="cardStatusOk ? 'polite' : 'assertive'">
                      <span class="status-icon" aria-hidden="true">
                        @if (!cardStatusOk) {
                          <svg viewBox="0 0 24 24" width="20" height="20">
                            <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm1 14h-2v-2h2v2Zm0-4h-2V6h2v6Z" />
                          </svg>
                        }
                        @if (cardStatusOk) {
                          <svg viewBox="0 0 24 24" width="20" height="20">
                            <path
                              d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm-1 14-4-4 1.414-1.414L11 12.172l4.586-4.586L17 9l-6 7Z" />
                          </svg>
                        }
                      </span>
                      <div class="status-text">
                        <p class="status-message">{{ cardStatusMsg }}</p>
                      </div>
                    </div>
                  }
                </form>
              </div>
            } @else {
              <div>
                <p class="h5">Pagamento via Cartão de Crédito</p>
                <p>Selecione a forma de pagamento para continuar.</p>
              </div>
            }
          </section>
        }

        @if (checkoutForm.value.paymentMethod === 'pix' && pixQrCodeUrl) {
          <section
            class="pix-data">
            <p class="h5">Pagamento via PIX</p>
            <form [formGroup]="checkoutForm">
              <div class="container-pix">
                <!-- Informações do PIX -->
                @if (pixAmount > 0) {
                  <div class="pix-info mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="text-muted">Valor:</span>
                      <strong class="h4">{{ getPixAmountFormatted() }}</strong>
                    </div>
                    @if (pixExpiresAt) {
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <span class="text-muted">Validade:</span>
                        <span class="badge bg-warning">{{ getPixExpirationTime() }}</span>
                      </div>
                    }
                  </div>
                }
                <!-- QR Code -->
                <div class="d-flex justify-content-center align-items-center mb-3">
                  <qr-code [value]="pixQrCodeUrl" size="300" errorCorrectionLevel="M" />
                </div>
                <!-- Status em tempo real -->
                <div class="status-payment mb-3">
                  @if (this.loading) {
                    <p>Carregando...</p>
                  } @else {
                    <div
                      class="alert"
                    [ngClass]="{
                      'alert-info': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
                      'alert-success': statusPaymentPix === 'PAGO',
                      'alert-danger': statusPaymentPix === 'FALHOU',
                    }">
                      <div class="d-flex align-items-center">
                        <i
                          class="fas me-2"
                        [ngClass]="{
                          'fa-clock': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
                          'fa-check-circle': statusPaymentPix === 'PAGO',
                          'fa-times-circle': statusPaymentPix === 'FALHOU',
                        }"></i>
                        <span>{{ statusPaymentPix }}</span>
                      </div>
                      <!-- Indicador de conexão WebSocket -->
                      <small class="d-block mt-2">
                        <i
                          class="fas fa-wifi me-1"
                          [class.text-success]="isWebSocketConnected"
                        [class.text-muted]="!isWebSocketConnected"></i>
                        {{
                        isWebSocketConnected
                        ? "Conectado - Aguardando confirmação em tempo real"
                        : "Verificando periodicamente"
                        }}
                      </small>
                    </div>
                  }
                </div>
                <!-- PIX Copia e Cola -->
                <div class="mb-3">
                  <label class="form-label">PIX Copia e Cola</label>
                  <input type="text" class="form-control" name="copiaECola" [value]="this.pixCopyPasteCode" readonly />
                </div>
                <!-- Botões de ação -->
                <div style="display: flex; flex-direction: column; gap: 16px">
                  <app-button (click)="copyPixKey()">
                    <i class="fas fa-copy me-2"></i>
                    Copiar Código PIX
                  </app-button>
                  <app-button styleType="secondary" (click)="goToMyOrders()">
                    <i class="fas fa-ticket-alt me-2"></i>
                    Ver Meus Ingressos
                  </app-button>
                </div>
              </div>
            </form>
          </section>
        }

        @if (shouldShowSuccessMessage() || shouldShowErrorMessage()) {
          <div class="status-container">
            @if (shouldShowSuccessMessage()) {
              <div class="status-banner success">
                <div class="status-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path
                      d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm-1 14-4-4 1.414-1.414L11 12.172l4.586-4.586L17 9l-6 7Z" />
                  </svg>
                </div>
                <div class="status-content">
                  <h3>Pagamento Aprovado!</h3>
                  <p>{{ paymentStatusMessage }}</p>
                </div>
              </div>
            }
          </div>
        }

        @if (!pixQrCodeUrl) {
          <div class="mt-3">
            @if (showCreditCardForm) {
              <app-button
                styleType="success"
                (click)="onCreditCardPay()"
                [disabled]="cardProcessing || !cardForm.valid"
                class="w-100">
                @if (!cardProcessing) {
                  <span>Finalizar pagamento</span>
                }
                @if (cardProcessing) {
                  <span class="spinner" aria-label="Processando..."></span>
                }
              </app-button>
            } @else {
              <app-button
                styleType="success"
                [disabled]="
                  this.loading || (this.checkoutForm.value.paymentMethod == 'credit_card' && !this.showCreditCardForm)
                "
                (click)="onSubmit()">
                {{ this.loading ? "Carregando..." : "Finalizar Pagamento" }}
              </app-button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Payment Processing Overlay -->
<app-payment-processing-overlay
  [isVisible]="showPaymentOverlay"
  [currentStep]="currentPaymentStep"
  [errorMessage]="paymentOverlayError"
  [paymentMethod]="checkoutForm.value.paymentMethod || 'credit_card'">
</app-payment-processing-overlay>
